import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

type Row = { id: string; admin_id: string; action: string; target_type: string | null; target_id: string | null; details: any; created_at: string };

export const AuditLogTab = () => {
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    supabase.from("admin_audit_log").select("*").order("created_at", { ascending: false }).limit(200)
      .then(({ data }) => setRows((data as Row[]) || []));
  }, []);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>When</TableHead>
          <TableHead>Admin</TableHead>
          <TableHead>Action</TableHead>
          <TableHead>Target</TableHead>
          <TableHead>Details</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id}>
            <TableCell className="whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</TableCell>
            <TableCell className="font-mono text-xs">{r.admin_id.slice(0, 8)}</TableCell>
            <TableCell>{r.action}</TableCell>
            <TableCell className="text-xs">{r.target_type ? `${r.target_type}:${r.target_id?.slice(0, 8)}` : "—"}</TableCell>
            <TableCell className="text-xs text-muted-foreground max-w-xs truncate">{JSON.stringify(r.details)}</TableCell>
          </TableRow>
        ))}
        {rows.length === 0 && (
          <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground">No audit entries yet.</TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  );
};
